import { createContext, useContext } from "react";

export type CustomTabContextType = {
  tab: number;
  setTab: (value: number) => void;
};

export const CustomTabContext = createContext<CustomTabContextType | null>(
  null,
);

export const useCustomTab = () => {
  const context = useContext(CustomTabContext);

  if (!context) {
    throw new Error(
      "useCustomTabContext must be used within a CustomTabContextProvider",
    );
  }

  return context;
};
